<template>
  <div class="join-us">
    <div class="join-img">
       <img src="@/assets/applyHead.png" alt="">
    </div>
    <div class="p"></div>
    <div class="join-main">
      <div class="main">
        <h3 class="title">百生跃试剂试用装申请</h3>
        <p class="huan">欢迎您参加百生跃生物试剂系列产品免费试用活动,请完整填写申请表,以便寄送</p>
        <div class="line"></div>
        <div class="apply">
          <p class="apply-title">申请人基本信息</p>
          <div class="apply-box">
            <div class="apply-box-left">
              <el-form :label-position="labelPosition" :rules="rules" label-width="100px" :model="forData">
                <el-form-item label="姓名" prop="username">
                  <el-input v-model="forData.username"></el-input>
                </el-form-item>
                <el-form-item label="Email" prop="email">
                  <el-input v-model="forData.email"></el-input>
                </el-form-item>
                <el-form-item label="选择地区" prop="district">
                  <el-cascader v-model="district" :props="props" :key="keyprop" @change="handleChange" @blur="districtBlur()" clearable></el-cascader>
                  <div style="color:#F56C6C" v-if="this.errorText !== ''">{{this.errorText}}</div>
                </el-form-item>
              </el-form>
            </div>
            <div class="apply-box-right">
              <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="forData">
                <el-form-item label="电话" prop="mobile">
                  <el-input v-model="forData.mobile"></el-input>
                </el-form-item>
                <el-form-item label="单位" prop="company">
                  <el-input v-model="forData.company"></el-input>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="forData.address"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="apply-productList">
          <p class="apply-title">试用商品列表(每次最多只能申请三个,最少选择一个)</p>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            stripe
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
          >
            <el-table-column label="商品货号" width="110">
              <template slot-scope="scope"><span class="huohao" style="cursor: pointer;" @click="goxq(scope.row.goods_code)">{{ scope.row.goods_code }}</span></template>
            </el-table-column>
            <el-table-column prop="name" label="中文名称" width="280"></el-table-column>
            <el-table-column prop="name_en" label="英文名称" width="250" show-overflow-tooltip></el-table-column>
            <el-table-column prop="spec" label="试用装规格" width="80" show-overflow-tooltip></el-table-column>
             <el-table-column prop="num" label="数量" width="120">
              <!-- <template slot-scope="scope">
                <el-input-number v-model="scope.row.num" @change="handleChanges" :min="1"></el-input-number>
              </template> -->
             </el-table-column>
            <el-table-column type="selection" width="55" label="试用申请"></el-table-column>
          </el-table>
        </div>
        <div class="form" id="subject">
          <el-form :label-position="labelPosition" ref="answerTips" label-width="80px" :rules="ruless" :model="forData">
               <el-form-item label="研究课题方向" prop='subject'>
                  <el-input v-model="forData.subject" placeholder="请输入研究课题方向"></el-input>
                </el-form-item>
                <el-form-item label="现使用品牌" prop="brand">
                  <el-input v-model="forData.brand" placeholder="请输入现使用品牌"></el-input>
                </el-form-item>
                <el-form-item label="年度使用量" prop="annual_usage">
                  <el-input v-model="forData.annual_usage" placeholder="请输入年度使用量"></el-input>
                </el-form-item>
                <el-form-item label="需求备注">
                    <el-input
                      type="textarea"
                      placeholder="请填写您的产品需求..."
                      v-model="forData.remark"
                      show-word-limit
                    ></el-input>
                </el-form-item>
          </el-form>
        </div>
        <div class="apply-rule">
          <p class="apply-title">试用申请规则</p>
          <div class='box'>
            <p>1.请注册网站并登录，认真填写申请信息，工作人员电话确认后及时安排发送;</p>
            <p>2.试用装免费提供，运输包装费从个人账户中的预存款抵扣;</p>
            <p>3.试用装每人最多只能同时申请三个类别，已经申请使用过的用户不再提供，请谅解;</p>
            <p>4.试用装寄出后，我们会根据您的试用时间安排电话回访;</p>
            <p>5.试用反馈流程: 关注"百生跃试剂"公众号,回复关键词"试用反馈",点击回复链接提交试用反馈表</p>
            <p>6.此试用活动只针对终端客户</p>
            <p>7.活动解释权归上海百生跃生物科技有限公司所有</p>
          </div>
        </div>
        <div class="submit"><button @click="trySubmit('answerTips')">提交</button></div>
      </div>
    <div class="apply-bottom">
       <img src="@/assets/applyBottom.png" alt="">
    </div>
    </div>
    <Bottom></Bottom>
    <div class="rightfixed">
      <ul :class="searchBarFixed == true ? 'isFixed' : ''">
        <rightFixed></rightFixed>
      </ul>
    </div>
    </div>
  </div>
</template>

<script>
import rightFixed from "../productCenter/components/rightFixed";
import Bottom from '../../components/bottom'
export default {
  name: "join-us",
  data() {
    return {
      searchBarFixed: false,
      offsetTop: 0,
      ptitle: "走进百生跃",
      navtype: "three",
      labelPosition: "right",
      forData: {
        username: "",
        email: "",
        mobile: "",
        company: "",
        address:"" ,
        province_code:'',
        city_code:'',
        district_code:'',
        remark:'',
        annual_usage:'',
        brand:'',
        subject:'' ,
        trial:[]
      },
      keyprop:1000,
      district: [],
      errorText:'',
      props: {
        lazy: true,
        lazyLoad: this.cascaderDistrict
      },
      tableData: [],
      rules: {
            username: [
              { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            email: [
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
            ],
            mobile: [
              { required: true, message: '请输入手机号', trigger: 'blur' },
              { pattern: /^1[3|4|5|6|7|8|9]\d{9}$/, message: '请输入正确的号码格式', trigger: 'change' }
            ],
            company: [
              { required: true, message: '请输入公司名称', trigger: 'blur' }
            ],
            address: [
              { required: true, message: '请输入详细地址', trigger: 'blur' }
            ],
             district: [
              { required: true, message: '请选择地区', trigger: 'blur'}
            ],
          },
          ruless:{
            subject: [
              { required: true, message: '请输入研究课题方向', trigger: 'blur' }
            ],
            brand: [
              { required: true, message: '请输入现使用品牌', trigger: 'blur' }
            ],
            annual_usage: [
              { required: true, message: '请输入年度使用量', trigger: 'blur'}
            ],
          }
      };
  },
  components: {
    rightFixed,
    Bottom
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    districtBlur(){
      if(this.district.length<1){
         this.errorText = '请选择地区'
      }else{
        this.errorText = ''
      }
      console.log(this.errorText,'errpr')
    },
    handleChanges(val){},
   cascaderDistrict(node,resolve){ 
       const { level } = node;
        const { data } = node;
        let parentCode = data ? data.value : "0";
        this.$api.address.district({
            code: parentCode
          }).then(res=>{
              const nodes = res.data
              .map(item => ({
                  value: item.adcode,
                  label: item.name,
                  leaf: level >= 2
              }));
              resolve(nodes);
      })
    },
    handleChange(value) {
      this.errorText = ''
      this.forData.province_code = value[0],
      this.forData.city_code = value[1],
      this.forData.district_code = value[2],
      this.keyprop++
    },
    tableRowClassName({row, rowIndex}) {
        if (rowIndex % 2 === 1 ) {
          return 'success-row';
        } else{
          return 'warning-row';
        }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      if(0 < val.length <=  3){
        var newarr = []
        val.forEach((item)=>{
          // newarr.push(item.sku_id)
          // var newidarr  = Array.from(new Set(newarr))
          // this.forData.trial  = Array.isArray(newidarr) ? newidarr.map((i) => i).join(",") : newidarr;
          newarr.push({id:item.sku_id,num:item.num})
          var newidarr  = Array.from(new Set(newarr))
          this.forData.trial = newidarr
        })
        }else{
          this.$message.closeAll()
          this.$message.warning('每次最多只能申请三个 , 最少选择一个最多只能选择三个')
        }
    },
    goxq(id) {
      this.$router.push({
        path: `/homepage/detail`,
        query: {
          id: id,
        }
      })
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector(".rightfixed").offsetTop;
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
    trySubmit(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
            this.$api.tryApply.applySubmit({
              ...this.forData
            }).then(res=>{
            if(res.status == 1){
                this.$router.push({
                  path: "/orderSubmit",
                  query: { type: "tryOut" },
                });
              }else if (res.status == 0){
                this.$message.closeAll()
                this.$message.warning(res.msg)
              }
            })
        }else{
          return false
        }
      })
     
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
     this.$api.productCenter.tryGoodsList({}).then(res=>{
       const data = res.data
       data.forEach(item=>{
         item.num = 1
       })
      this.tableData = data
    })
    this.$api.personalInfo.getuser({}).then((res) => {
      if (res.status == 1) {
        this.forData = res.data;
        this.district = [res.data.province_code,res.data.city_code,res.data.district_code]
      } else if(res.status == 0){
        this.$message.closeAll()
        this.$message.warning();
      }else{}
    });
  },
};
</script>

<style lang="less" scoped>
/deep/.el-table{
  width: 100%;
  .el-table__header-wrapper table,.el-table__body-wrapper table{
    width: 100% !important;
  }
  .el-table__body, .el-table__footer, .el-table__header{
    table-layout: auto;
  }
}
#subject{
  /deep/.el-form-item__error {
    position: absolute;
    top: 100%;
    left: 50px;
}
}
.join-us {
  width: 1920px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  position: relative;
  .rightfixed {
    width: 90px;
    height: 230px;
    position: absolute;
    top: 550px;
    right: 10px;
    .isFixed {
      position: fixed;
      bottom: 150px;
      z-index: 999;
    }
  }
  .box-one {
    width: 1510px;
    height: 316px;
    background: #f6f6f6;
    margin: auto;
    background: url("../../images/four.png");
  }
  .p {
    height: 15px;
    line-height: 15px;
  }
  .join-main {
    width: 1510px;
    min-height: 500px;
    background: #ffffff;
    margin: auto;
    margin-bottom: 20px;
    font-size: 16px;
    .main {
      width: 1210px;
      margin: auto;
    }
    .title {
      text-align: center;
      font-size: 24px;
      padding: 10px;
    }
    .huan{
      color:#000;
      letter-spacing:3px;
    }
    .line {
      height: 10px;
      line-height: 10px;
      border-bottom: 1px solid #000;
    }
    .apply-title {
      font-size: 20px;
      color:#000;
      margin-bottom: 20px;
    }
    .huohao:hover{
      color:#ffbb00;
    }
    .apply {
      margin-top: 10px;
      .apply-box {
        display: flex;
        justify-content: space-between;
        /deep/ .el-input {
          width: 400px !important;
        }
      }
    }
    .apply-productList{
    /deep/.el-table th,
      .el-table tr {
        background: #003871;
        color: #fff;
        font-size:16px;
      }
      /deep/.el-table__header-wrapper  .el-checkbox{
          display:none
        }
      /deep/.el-table .warning-row {
        // background: #cfd5ea;
        height: 70px;
        color:#000;
      }
      /deep/.el-table .success-row {
        // background: #e9ebf5;
        height: 70px;
        color:#000;
      }
    }
    .form{
      margin-top: 20px;
      margin-bottom: 50px;
      /deep/.el-form-item__label{
        width: 130px !important;
        font-size:18px !important;
      }
      /deep/.el-input__inner,.el-input{
        width: 800px !important;
      }
      /deep/ .el-textarea__inner{
        width: 800px;
        height:180px;
        margin-left: 45px;
        font-size:18px;
      }
    }
    .apply-rule{
      .box{
        margin-bottom: 30px;
        p{
          letter-spacing:3px;
          height:30px;
          line-height:30px;
          color:#000;
        }
      }
    }
    .submit{
      width: 120px;
      height:50px; 
      margin: 20px auto;
      button{
        width: 120px;
        height:50px;
        color:#fff;
        background: #003871;
        border:0px;
        border-radius: 5px;
        font-size:18px;
      }
    }
  }
  .apply-bottom{
    width: 100%;
    img{
      width: 100%;
      height:400px;
    }
  }
  .join-img {
    width: 100%;
    img {
      width: 1920px;
      height: 500px;
    }
  }
  .five {
    width: 805px;
    height: 49px;
    margin: auto;
    margin-top: 15px;
    font-size: 14px;
    text-align: center;
    color: #666666;
    line-height: 24px;
    span {
      font-size: 14px;
      text-align: center;
      color: #666666;
      line-height: 24px;
    }
  }
}

  /deep/.el-input-number{
    width: 108px !important;
  }
  /deep/.el-input-number__decrease{
    width: 25px !important;
  }
  /deep/.el-input-number__increase{
    width: 25px !important;
  }
  /deep/.el-input-number .el-input__inner{
        padding-left:0px !important;
        padding-right:0px !important;
  }
</style>